<script>
import { Label } from '@/api'
import fields from '@/components/fields/'
import FormMixin from '@/crudBases/form/FormMixin'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Label List' }
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa',
          required: true,
          modelPath: [this, 'form', 'name']
        }),
        new fields.ColorPicker({
          label: 'Kolor',
          required: true,
          modelPath: [this, 'form', 'color']
        })
      ]
    }
  },
  computed: {
    service() {
      return Label
    }
  }
}
</script>
